import React from "react";

function SizeGuide() {
  return (
    <div className="space-y-8 bg-slate-50 py-8 max-w-full mx-auto px-1 md:px-10">
      <div className="grid grid-cols-1 overflow-x-hidden ">
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="5688">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-3">
                  Womens Size Chart
                </h2>
                <div>
                  <p className="mx-auto px-6">
                    Find your perfect clothing size with the boohoo size guide.
                    Whether you want a dress or jeans, find the perfect clothing
                    sizing match with our size converter. For the most accurate
                    results, follow this boohoo size chart and take your body
                    measurements in only your underwear.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2 overflow-visible">
            <div __typename="ComponentComponentsText" id="5687">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-5">
                  Main Range
                </h2>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200"></th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          XS
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          S
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          M
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          L
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          XL
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          XXL
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          XXXL
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          XXXXL
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          UK
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          4
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          6
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          8
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          10
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          12
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          14
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          16
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          18
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          20
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          22
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          24
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          26
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          AUS / NZ
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          4
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          6
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          8
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          10
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          12
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          14
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          16
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          18
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          20
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          22
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          24
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          26
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          USA / CAN
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          0
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          2
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          4
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          6
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          8
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          10
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          12
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          14
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          16
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          18
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          20
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          22
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          24
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          26
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          26
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          EU FR
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          50
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          52
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          56
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          EU DE
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          50
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          52
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          56
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          56
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          EU ITALY
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          50
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          52
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          56
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          60
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          62
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          62
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          BUST (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          82.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          90
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          95
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          100
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          105
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          111
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          117
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          123
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          129
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          135
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          141
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          147
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          153
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          BUST (in)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          35.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          37.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          39.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          41.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          43.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          45.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          47.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          49
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          51
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          53
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          55
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          57
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          WAIST (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          62
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          64.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          67
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          77
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          82
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          87
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          93
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          99
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          105
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          111
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          117
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          123
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          129
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          135
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          WAIST (in)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          24.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          25.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          26.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          50
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          HIP (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          88
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          90.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          93
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          98
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          103
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          108
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          113
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          119
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          125
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          131
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          137
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          143
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          149
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          155
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          161
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          HIP (in)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          35.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          50.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          52
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          56
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          60
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="5754">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800">
                  Womens Trousers
                </h2>
                <div>
                  <p className="mx-auto px-6">
                    *Actual garment inside leg length will vary according to
                    style
                  </p>
                </div>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200"></th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Main
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Plus
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Petite
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Tall
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Maternity
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Length guide only
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          To fit measurement
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          71
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          71
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          65
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          25.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          77
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          71
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Wide leg trousers - casual
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78-80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78-80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70-72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5-28.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          84-85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33-33.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78-80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-31.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Wide leg trousers - going out
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          74
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          86-87
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34-34.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Ankle grazer trouser
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          64
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          25
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          76
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Legging
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          65
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          25.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Culotte
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54-60
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          21-23.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54-60
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          21-23.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48-54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          19-21.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          60-68
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          23.5-26.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          54-60
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          21-23.5
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="6138">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-3">
                  Womens Jeans
                </h2>
                <div>
                  <p className="mx-auto px-6">
                    *Actual garment inside leg length will vary according to
                    style
                  </p>
                </div>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200"></th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Main
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Plus
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Petite
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Tall
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Maternity
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Length guide only
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          To fit measurement- inside leg on the body to the
                          floor
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          76
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          73
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Skinny Jean
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          73
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          64
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          25
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          73
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Mom Jean
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          75
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          74
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          67
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          26.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          75
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Straight leg Jean
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          83
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Wide leg Jean
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          78-80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          71
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          84
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Slouchy wide leg Jean
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79-80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          82
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          71
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          84
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79-80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-31.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Flared Jean
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          82
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          72
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          28.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="6141">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-3">
                  Standard Skirt Lengths
                </h2>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200"></th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Main
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Plus
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Petite
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Tall
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Maternity
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Length guide only
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Mini
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          37-39
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          14.5-15.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          43
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          17
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34-36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          13.5-14
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          39-41
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          15.5-16
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          37-39
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          14.5-15.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Skater
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44-47
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          17-18.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          47-54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          18.5-21
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          41-44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          16-17.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          39-41
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          15.5-16
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44-47
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          17-18.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Midi
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70-81
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5-32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          73-90
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          29-35.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          65
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          25.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          76
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          70-81
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          27.5-32
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Midaxi
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          85-91
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33.5-36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          88-95
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          35-37
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80-85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5-33.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          89-94
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          35-37
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          85-91
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33.5-36
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Maxi
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          103-112
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40.5-44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          105-112.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          41-44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          97-104
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38-41
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          110-117
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          43-46
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          103-112
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40.5-44
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="6154">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-3">
                  Standard Dress Lengths From Shoulder
                </h2>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200"></th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Main
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Plus
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Petite
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Tall
                        </th>
                        <th
                          className="px-3 py-2 font-semibold text-left border-b border-slate-200"
                          colSpan="2"
                        >
                          Maternity
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Length guide only
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (cm)
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          (inches)
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Mini
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          83-85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32.5-33.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          91
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79-81
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31-32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          88-90
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34.5-35.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          83-85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32.5-33.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Skater
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          84-86
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33-34
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          93
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          80-82
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          31.5-32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          88-90
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34.5-35.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          84-86
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          33-34
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Midi
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          110-123
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          43-48.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          125
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44.5-50
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          110
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          43
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          123
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          110-123
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          43-48.5
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Midaxi
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          130-136.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          51-54
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          135
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          52-55
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          120-125
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          47-49
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          131-136
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          51.5-53.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          130-136.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          51-54
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          Maxi
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          148-153.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58-60.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          150-152
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58-61
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          140-145
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          55-57
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          157-161
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          61.5-63.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          148-153.5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          58-60.5
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="5755">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-3">
                  Womens Footwear
                </h2>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          UK
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          3
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          4
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          5
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          6
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          7
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          8
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          9
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          EU
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          37
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          39
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          41
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          USA / CAN
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          5
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          6
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          7
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          8
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          9
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          10
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          11
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-screen-2xl max-w-[100vw] mx-auto py-2">
            <div __typename="ComponentComponentsText" id="5756">
              <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                <h2 className="text-2xl font-bold text-slate-800 py-3">
                  Womens Bras
                </h2>
                <h3>Bra Sizes</h3>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          EU BRA SIZE
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          65
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          70
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          75
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          80
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          85
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          90
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          95
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          100
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          105
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          EU SHIRT SIZE
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34-36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36-38
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38-40
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40-42
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42-44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44-46
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46-48
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          48-50
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          50-52
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          GB BRA SIZE
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          30
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          32
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          34
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          36
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          38
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          40
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          42
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          44
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          46
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          GB SHIRT SIZE
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          8
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          10
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          12
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          14
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          16
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          18
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          20
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          22
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          24
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h3>Cup Sizes</h3>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-slate-200 bg-white text-sm shadow-sm ring-1 ring-slate-200 rounded-xl">
                    <thead className="bg-slate-50 text-left text-xs uppercase tracking-[0.08em] text-slate-500">
                      <tr>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          UNDERBUST
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          63-67
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          68-72
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          73-77
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          78-82
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          83-87
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          88-92
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          93-97
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          98-102
                        </th>
                        <th className="px-3 py-2 font-semibold text-left border-b border-slate-200">
                          103-107
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200 bg-white">
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          CUP A
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          77-79
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          82-84
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          87-89
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          92-94
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          97-99
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          102-104
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          107-109
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          112-114
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          117-119
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          CUP B
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          79-81
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          84-86
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          89-91
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          94-96
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          99-101
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          104-106
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          109-111
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          114-116
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          119-121
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          CUP C
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          81-83
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          86-88
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          91-93
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          96-98
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          101-103
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          106-108
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          111-113
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          116-118
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          121-123
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          CUP D
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          83-85
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          88-90
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          93-95
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          98-100
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          103-105
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          108-110
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          113-115
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          118-120
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          123-125
                        </td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          CUP E / DD
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          85-87
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          90-92
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          95-97
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          100-102
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          105-107
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          110-112
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200"></td>
                        <td className="px-3 py-2 border-b border-slate-200"></td>
                        <td className="px-3 py-2 border-b border-slate-200"></td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 border-b border-slate-200">
                          CUP F
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          87-89
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          92-94
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          97-99
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          102-104
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          107-109
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200">
                          112-114
                        </td>
                        <td className="px-3 py-2 border-b border-slate-200"></td>
                        <td className="px-3 py-2 border-b border-slate-200"></td>
                        <td className="px-3 py-2 border-b border-slate-200"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SizeGuide;
